
<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="">

  <runner-journal-view [clientUserId]="clientUserId" [isCoachView]="true"></runner-journal-view>
</div>


